<template>
<div class="chapter">
<div class="inner_page">
<p class="C118_14"><a id="page_1">OCCUPY</a></p><a id="page_1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Half_Tit.vue?94e81906